export { default } from './CompactBriefMobile';
